import { createAppContext } from './create-app-context';

export interface AuthContext {
    getAuthToken: () => Promise<string>;
}

export const { AppContextProvider: AuthContextProvider, useAppState: useAuthContext } = createAppContext<AuthContext>();
